module.exports = __webpack_public_path__ + "media/הוא.c9a2e7d7.mp3";